import { render } from "./ProjectDetailPage.vue?vue&type=template&id=36a9f602"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__